import { LogCategory, TraceLevel } from "@1js/office-online-jsapi-core";
var logger;
export var localStorage = getLocalStorage();
function getLocalStorage() {
    var storage = undefined;
    try {
        storage = window.localStorage;
    }
    catch (error) {
        // ASSERTTAG_IGNORE_START
        logger === null || logger === void 0 ? void 0 : logger.ULS.sendTraceTag(0x1f7094d3 /* tag_52jtt */, LogCategory.msoulscat_Wac_UnifiedUiHost, TraceLevel.Warning, "Access to LocalStorage has been blocked!");
        // ASSERTTAG_IGNORE_FINISH
    }
    return storage;
}
//# sourceMappingURL=getLocalStorage.js.map